//angular
import { Injectable, signal, WritableSignal } from "@angular/core";

/**
 * @summary A service that stores basic shared state for the entire app
 */
@Injectable({
    providedIn: 'root'
})
export class CoreStateService  {

    public testMode: WritableSignal<boolean> = signal(false);
}